import PaginationParameters from "./pagination/pagination-parameters";
import { FilterParameters } from "_shared/_api/queries/filtering/filter-parameters";
import { OrderParameters } from "_shared/_api/queries/ordering/order-parameters";

export abstract class Query<FP extends FilterParameters, OP extends OrderParameters, PP extends PaginationParameters> {
  public readonly filterParameters: FP;
  public readonly orderParameters: OP;
  public readonly paginationParameters: PP;

  public get searchParams(): URLSearchParams {
    return new URLSearchParams([
      ...this.paginationParameters.searchParams,
      ...this.orderParameters.searchParams,
      ...this.filterParameters.searchParams,
    ]);
  }

  public get cacheKey(): string {
    const params = this.searchParams;
    const sortedEntries = [...params.entries()].sort((a, b) => a[0].localeCompare(b[0]));
    return sortedEntries.map(([k, v]) => `${k}=${v}`).join("&");
  }

  protected constructor(params: { filterParameters: FP; orderParameters: OP; paginationParameters: PP }) {
    this.filterParameters = params.filterParameters;
    this.orderParameters = params.orderParameters;
    this.paginationParameters = params.paginationParameters;
  }
}
